import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("pending");
  const tries = useRef(0);
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      setStatus("error");
      return;
    }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired") return setStatus("error");
      } catch (e) {
        return setStatus("error");
      }
      tries.current += 1;
      if (tries.current < 15) timer = setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="payment-success-page">
      {status === "pending" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-[#1E40AF]" /><p className="mt-4 text-slate-600" data-testid="payment-status-pending">Vérification du paiement…</p></>}
      {status === "paid" && <><CheckCircle2 className="mx-auto h-14 w-14 text-[#166534]" /><h1 className="mt-4 font-display text-3xl font-extrabold" data-testid="payment-status-paid">Abonnement activé !</h1><p className="mt-2 text-slate-600">Vous pouvez maintenant compléter votre fiche.</p></>}
      {(status === "error" || status === "timeout") && <><XCircle className="mx-auto h-14 w-14 text-red-500" /><h1 className="mt-4 font-display text-2xl font-bold" data-testid="payment-status-error">Paiement non confirmé</h1><p className="mt-2 text-slate-600">Si vous avez été débité, l'activation peut prendre quelques minutes.</p></>}
      <Link to="/mon-espace" className="mt-8 inline-block rounded-full bg-slate-900 px-6 py-3 font-semibold text-white hover:bg-[#1E40AF]" data-testid="payment-back-dashboard">Aller à mon espace</Link>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto h-14 w-14 text-slate-400" />
      <h1 className="mt-4 font-display text-2xl font-bold">Paiement annulé</h1>
      <p className="mt-2 text-slate-600">Aucun montant n'a été débité.</p>
      <Link to="/mon-espace" className="mt-8 inline-block rounded-full bg-slate-900 px-6 py-3 font-semibold text-white hover:bg-[#1E40AF]" data-testid="payment-cancel-back">Retour à mon espace</Link>
    </div>
  );
}
